import { flatConnectionStates } from '@fttb/common';
import { POPUP_CONNECTION_STATE, popupSteps } from "../../../../store/common/constants";
export var getNotificationFill = function getNotificationFill(status) {
  if (status === POPUP_CONNECTION_STATE.alreadyInUse || status === POPUP_CONNECTION_STATE.isNotAvailable || status === POPUP_CONNECTION_STATE.houseIsNotFound || status === POPUP_CONNECTION_STATE.streetIsNotFound) {
    return '#F45151';
  }
  if (status === POPUP_CONNECTION_STATE.isAvailable || status === POPUP_CONNECTION_STATE.highSpeedAvailable || status === POPUP_CONNECTION_STATE.isHighSpeedAvailableWithoutCalendarStep || status === POPUP_CONNECTION_STATE.isExists) {
    return '#1790FF';
  }
  return null;
};
export var getConnectionStatus = function getConnectionStatus(_ref) {
  var ConnectionState = _ref.ConnectionState,
    HighSpeedAvailable = _ref.HighSpeedAvailable;
  if (ConnectionState === flatConnectionStates.success && (HighSpeedAvailable === 1 || HighSpeedAvailable === 2)) {
    return POPUP_CONNECTION_STATE.highSpeedAvailable;
  }
  if (ConnectionState === flatConnectionStates.alreadyInUse) {
    return POPUP_CONNECTION_STATE.alreadyInUse;
  }
  if (ConnectionState === flatConnectionStates.none) {
    return POPUP_CONNECTION_STATE.isNotAvailable;
  }
  return POPUP_CONNECTION_STATE.isAvailable;
};
export var getStepStatus = function getStepStatus(_ref2) {
  var IsSucceeded = _ref2.IsSucceeded,
    _ref2$View = _ref2.View,
    ConnectionState = _ref2$View.ConnectionState,
    HasRequestOnAddress = _ref2$View.HasRequestOnAddress,
    HighSpeedAvailable = _ref2$View.HighSpeedAvailable,
    isHighSpeedTariff = _ref2.isHighSpeedTariff;
  if (!IsSucceeded) {
    return popupSteps.fail;
  }
  if (HasRequestOnAddress) {
    return popupSteps.alreadyInUse;
  }
  if ((ConnectionState === flatConnectionStates.success || ConnectionState === flatConnectionStates.alreadyInUse) && HighSpeedAvailable === 0 && isHighSpeedTariff) {
    return popupSteps.alternativeTariff;
  }
  return popupSteps.addressRequestForm;
};
export var composeConnectionData = function composeConnectionData(_ref3) {
  var checkAddressType = _ref3.checkAddressType,
    flat = _ref3.flat,
    house = _ref3.house,
    isConvergentRequest = _ref3.isConvergentRequest,
    region = _ref3.region,
    street = _ref3.street;
  return {
    checkAddressType: checkAddressType,
    cityId: region.id,
    city: region.label,
    flat: flat,
    house: house.label,
    houseId: house.id,
    isConnected: house.isConnected,
    isConvergentRequest: isConvergentRequest,
    street: street.label,
    streetId: street.id
  };
};
export var getQueryParams = function getQueryParams(urlParams) {
  return new URLSearchParams(urlParams).toString();
};
var camelize = function camelize(str) {
  return str.replace(/-.|_./g, function (x) {
    return x[1].toUpperCase();
  });
};
export var formatCommonKeys = function formatCommonKeys(texts) {
  return texts.reduce(function (acc, curr) {
    acc[camelize(curr.key)] = curr.content;
    return acc;
  }, {});
};